module.exports = __webpack_public_path__ + "static/media/Poliwag_gaussian2.44ee8af6.png";